var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    wfill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8.05753L10.06 5.125L7.06001 8.875L4.75 6.55753L3.55748 7.75H1V14.5C1 14.8978 1.15806 15.2793 1.43936 15.5606C1.72067 15.8419 2.10218 16 2.5 16H14.5C14.8978 16 15.2793 15.8419 15.5606 15.5606C15.8419 15.2793 16 14.8978 16 14.5V6.25H14.8075L13 8.05753ZM4.75 14.5H3.25V12.25H4.75V14.5ZM7.75 14.5H6.25V10.75H7.75V14.5ZM10.75 14.5H9.25V12.25H10.75V14.5ZM13.75 14.5H12.25V10.75H13.75V14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 1H2.5C2.10218 1 1.72067 1.15806 1.43936 1.43936C1.15806 1.72067 1 2.10218 1 2.5V6.25H2.93501L4.75 4.44247L6.93999 6.625L9.93999 2.875L13 5.94247L14.185 4.75H16V2.5C16 2.10218 15.8419 1.72067 15.5606 1.43936C15.2793 1.15806 14.8978 1 14.5 1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/Overview.22b2d15e.svg";
export { ForwardRef as ReactComponent };